import { useEffect, useState } from "react";

export const useCookieConsent = () => {
  const [consent, setConsent] = useState({
    necessary: true,
    analytics: false,
    marketing: false,
  });

  useEffect(() => {
    const loadConsent = () => {
      try {
        const saved = localStorage.getItem("cookieConsent");
        if (saved) {
          const parsed = JSON.parse(saved);
          setConsent(parsed);
        }
      } catch (e) {
        console.error("Error loading cookie consent:", e);
      }
    };

    loadConsent();

    const handleConsentUpdate = (e) => {
      if (e?.detail) {
        setConsent(e.detail);
      } else {
        loadConsent();
      }
    };

    window.addEventListener("cookieConsentUpdated", handleConsentUpdate);
    return () => window.removeEventListener("cookieConsentUpdated", handleConsentUpdate);
  }, []);

  return consent;
};

export const hasCookieConsent = (category) => {
  try {
    const saved = localStorage.getItem("cookieConsent");
    if (!saved) return false;
    const consent = JSON.parse(saved);
    return consent?.[category] === true;
  } catch {
    return false;
  }
};

